jQuery(document).ready(function($) {
    'use strict';

    var windowWidth = $(window).outerWidth();

    $(document).on('click', '.popover--click', function () {

        var data = $(this).attr('data-tip');

        if ($(this).hasClass('popover-open')) {

            $(this).removeClass('popover-open');
            $(this).find('.popover-content').remove();

        } else {

            $(this).addClass('popover-open');
            $(this).append('<div class="popover-content">'+data+'</div>');
            $(this).find('.popover-content').fadeIn(200);

        }

    });

    if ( windowWidth > 1024 ) {

        $(document).on('mouseover', '.popover--hover', function () {

            var data = $(this).attr('data-tip');

            $(this).append('<div class="popover-content">'+data+'</div>');
            $(this).find('.popover-content').fadeIn(200);

        });

        $(document).on('mouseout', '.popover', function () {

            $(this).find('.popover-content').remove();

        });

    } else {

        $(document).on('click', '.popover--hover', function () {

            var data = $(this).attr('data-tip');

            if ($(this).hasClass('popover-open')) {

                $(this).removeClass('popover-open');
                $(this).find('.popover-content').remove();

            } else {

                $(this).addClass('popover-open');
                $(this).append('<div class="popover-content">'+data+'</div>');
                $(this).find('.popover-content').fadeIn(200);

            }

        });

    }



});
